import { render, staticRenderFns } from "./TableStockoutCreate.vue?vue&type=template&id=d2297ada&scoped=true&"
import script from "./TableStockoutCreate.vue?vue&type=script&lang=js&"
export * from "./TableStockoutCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2297ada",
  null
  
)

export default component.exports